<template>
  <div class="legend">
    <div class="legend-title">
      <div class="legend-title-text">{{ $t('text.legend') }}</div>
      <div class="legend-title-text">&</div>
      <div class="legend-title-text">{{ $t('text.filter').toUpperCase() }}</div>
    </div>
    <div class="legend-group">
      <div class="legend-group-title">{{ $t('text.cycle') }}</div>
      <div class="legend-item-wrapper">
        <div class="legend-item">
          <div class="pad-cycle"></div>
          <div class="legend-item-text">
            {{ $t('text.pad_cycle', { pad: $store.state.locale.pad }) }}
          </div>
        </div>
        <div class="legend-item">
          <div class="off-body-item">
            <div class="off-body-left"></div>
            <img src="@/assets/image/VoidingPatternIcon/off-body.svg" />
            <div class="off-body-right"></div>
          </div>
          <div class="legend-item-text">{{ $t('text.off_body') }}</div>
        </div>
      </div>
    </div>
    <div class="legend-group">
      <div class="legend-group-title">
        {{
          $t('text.pad_status_legend', {
            pad: $firstLetterCapitalize($store.state.locale.pad)
          })
        }}
      </div>
      <div class="legend-item-wrapper">
        <div class="legend-item">
          <div
            class="pad-group"
            :class="{
              'filter-selected': isFilterSelected(smartzEventConst.analysing)
            }"
            @click="updateFilters(smartzEventConst.analysing)"
          >
            <div class="smart-event-icon analysing-pad">
              <img src="@/assets/image/VoidingPatternIcon/analysing-pad.png" />
            </div>
          </div>
          <div class="legend-item-text">
            {{
              $t('text.analysing_diaper_legend', {
                pad: $store.state.locale.pad
              }).toLowerCase()
            }}
          </div>
        </div>
        <div class="legend-item">
          <div
            class="pad-group pad-used"
            :class="{
              'filter-selected': isFilterSelected(smartzEventConst.green)
            }"
            @click="updateFilters(smartzEventConst.green)"
          >
            <div class="green-pad smart-event-icon"></div>
            <div class="yellow-pad smart-event-icon"></div>
            <div class="red-pad smart-event-icon"></div>
          </div>
          <div class="legend-item-text">
            {{
              $t('text.dry_wet_change_diaper', { pad: $store.state.locale.pad })
            }}
          </div>
        </div>
        <div class="legend-item">
          <div
            class="pad-group"
            :class="{
              'filter-selected': isFilterSelected(smartzEventConst.padRemoved)
            }"
            @click="updateFilters(smartzEventConst.padRemoved)"
          >
            <div class="smart-event-icon pad-removed">
              <img src="@/assets/image/VoidingPatternIcon/pad-removed.svg" />
            </div>
          </div>
          <div class="legend-item-text">
            {{
              $t('text.diaper_removed_legend', {
                pad: $store.state.locale.pad
              }).toLowerCase()
            }}
          </div>
        </div>
        <div class="legend-item">
          <div
            class="pad-group"
            :class="{
              'filter-selected': isFilterSelected(
                smartzEventConst.diaperNotUsed
              )
            }"
            @click="updateFilters(smartzEventConst.diaperNotUsed)"
          >
            <div class="smart-event-icon diaper-not-selected">
              <img
                src="@/assets/image/VoidingPatternIcon/diaper-not-used.png"
              />
            </div>
          </div>
          <div class="legend-item-text">
            {{
              $t('text.brief_not_used', {
                pad: $firstLetterCapitalize($store.state.locale.pad)
              }).toLowerCase()
            }}
          </div>
        </div>
        <div class="legend-item">
          <div
            class="pad-group"
            :class="{
              'filter-selected': isFilterSelected(
                smartzEventConst.diaperNotSelected
              )
            }"
            @click="updateFilters(smartzEventConst.diaperNotSelected)"
          >
            <div class="smart-event-icon diaper-not-selected">
              <img
                src="@/assets/image/VoidingPatternIcon/diaper-not-selected.png"
              />
            </div>
          </div>
          <div class="legend-item-text">
            {{
              $t('text.diaper_not_selected', {
                pad: $store.state.locale.pad
              }).toLowerCase()
            }}
          </div>
        </div>
        <div class="legend-item">
          <div
            class="pad-group"
            :class="{
              'filter-selected': isFilterSelected(smartzEventConst.external)
            }"
            @click="updateFilters(smartzEventConst.external)"
          >
            <div class="smart-event-icon external-humidity">
              <img
                src="@/assets/image/VoidingPatternIcon/external-humidity.png"
              />
            </div>
          </div>
          <div class="legend-item-text">
            {{ $t('text.external_humidity').toLowerCase() }}
          </div>
        </div>
        <div class="legend-item">
          <div
            class="pad-group"
            :class="{
              'filter-selected': isFilterSelected(smartzEventConst.unstable)
            }"
            @click="updateFilters(smartzEventConst.unstable)"
          >
            <div class="smart-event-icon unstable">
              <img src="@/assets/image/VoidingPatternIcon/unstable.png" />
            </div>
          </div>
          <div class="legend-item-text">
            {{ $t('text.monitor_unstable_readings').toLowerCase() }}
          </div>
        </div>
        <div class="legend-item">
          <div
            class="pad-group"
            :class="{
              'filter-selected': isFilterSelected(smartzEventConst.leakage)
            }"
            @click="updateFilters(smartzEventConst.leakage)"
          >
            <div class="smart-event-icon leakage">
              <img src="@/assets/image/VoidingPatternIcon/leakage.svg" />
            </div>
          </div>
          <div class="legend-item-text">
            {{ $t('text.leakage').toLowerCase() }}
          </div>
        </div>
        <div class="legend-item">
          <div
            class="pad-group"
            :class="{
              'filter-selected': isFilterSelected(smartzEventConst.clumped)
            }"
            @click="updateFilters(smartzEventConst.clumped)"
          >
            <div class="smart-event-icon external-humidity">
              <img src="@/assets/image/VoidingPatternIcon/core-breakup.png" />
            </div>
          </div>
          <div class="legend-item-text">
            {{ $t('text.core_breakup').toLowerCase() }} /
            {{ $t('text.wetness_outside').toLowerCase() }}
          </div>
        </div>
        <div class="legend-item">
          <div
            class="pad-group"
            :class="{
              'filter-selected': isFilterSelected(
                smartzEventConst.sensorDisconnected
              )
            }"
            @click="updateFilters(smartzEventConst.sensorDisconnected)"
          >
            <div class="smart-event-icon sensor-disconnected">
              <img
                src="@/assets/image/VoidingPatternIcon/sensor-disconnected.png"
              />
            </div>
          </div>
          <div class="legend-item-text">
            {{ $t('text.sensor_disconnected').toLowerCase() }}
          </div>
        </div>
        <div class="legend-item">
          <div
            class="pad-group"
            :class="{
              'filter-selected': isFilterSelected(
                smartzEventConst.checkConnection
              )
            }"
            @click="updateFilters(smartzEventConst.checkConnection)"
          >
            <div class="smart-event-icon check-connection">
              <img
                src="@/assets/image/VoidingPatternIcon/check-connection.png"
              />
            </div>
          </div>
          <div class="legend-item-text">
            {{ $t('text.check_connection_status').toLowerCase() }}
          </div>
        </div>
      </div>
    </div>
    <div class="legend-group">
      <div class="legend-group-title">{{ $t('text.pod_status') }}</div>
      <div class="legend-item-wrapper">
        <div class="legend-item">
          <div
            class="pad-group"
            :class="{
              'filter-selected': isFilterSelected(smartzEventConst.outOfRange)
            }"
            @click="updateFilters(smartzEventConst.outOfRange)"
          >
            <div class="smart-event-icon out-of-range">
              <img src="@/assets/image/VoidingPatternIcon/out-of-range.png" />
            </div>
          </div>
          <div class="legend-item-text">
            {{ $t('text.out_of_range_legend').toLowerCase() }}
          </div>
        </div>
        <div class="legend-item">
          <div
            class="pad-group"
            :class="{
              'filter-selected': isFilterSelected(smartzEventConst.lowBattery)
            }"
            @click="updateFilters(smartzEventConst.lowBattery)"
          >
            <div class="smart-event-icon low-battery">
              <img src="@/assets/image/VoidingPatternIcon/low-battery.png" />
            </div>
          </div>
          <div class="legend-item-text">
            {{ $t('text.low_battery').toLowerCase() }}
          </div>
        </div>
        <div class="legend-item">
          <div
            class="pad-group"
            :class="{
              'filter-selected': isFilterSelected(smartzEventConst.newBattery)
            }"
            @click="updateFilters(smartzEventConst.newBattery)"
          >
            <div class="smart-event-icon new-battery">
              <img src="@/assets/image/VoidingPatternIcon/new-battery.svg" />
            </div>
          </div>
          <div class="legend-item-text">
            {{ $t('text.new_battery').toLowerCase() }}
          </div>
        </div>
        <div class="legend-item">
          <div
            class="pad-group"
            :class="{
              'filter-selected': isFilterSelected(smartzEventConst.checkBin)
            }"
            @click="updateFilters(smartzEventConst.checkBin)"
          >
            <div class="smart-event-icon check-bin">
              <img src="@/assets/image/NotificationIcons/pad-in-bin.png" />
            </div>
          </div>
          <div class="legend-item-text">
            {{ $t('text.check_bin').toLowerCase() }}
          </div>
        </div>
        <!-- <div class="legend-item">
          <div
            class="pad-group"
            :class="{
              'filter-selected': isFilterSelected(smartzEventConst.doubleTap)
            }"
            @click="updateFilters(smartzEventConst.doubleTap)"
          >
            <div class="smart-event-icon new-battery">
              <img src="@/assets/image/VoidingPatternIcon/double-tap.svg" />
            </div>
          </div>
          <div class="legend-item-text">
            {{ $t('text.double_tap').toLowerCase() }}
          </div>
        </div> -->
      </div>
    </div>
    <div class="legend-group">
      <div class="legend-group-title">{{ $t('text.goal_status') }}</div>
      <div class="legend-item-wrapper">
        <div class="legend-item">
          <div
            class="pad-group"
            :class="{
              'filter-selected': isFilterSelected(
                smartzEventConst.goalTimeExceed
              )
            }"
            @click="updateFilters(smartzEventConst.goalTimeExceed)"
          >
            <div class="smart-event-icon">
              <img
                class="wp-100"
                src="@/assets/image/VoidingPatternIcon/time-to-change.png"
              />
            </div>
          </div>
          <div class="legend-item-text">
            {{ $t('text.exceed_goal_time').toLowerCase() }}
          </div>
        </div>
        <div class="legend-item">
          <div
            class="pad-group"
            :class="{
              'filter-selected': isFilterSelected(smartzEventConst.fall)
            }"
            @click="updateFilters(smartzEventConst.fall)"
          >
            <div class="smart-event-icon fall">
              <img src="@/assets/image/VoidingPatternIcon/fall.png" />
            </div>
          </div>
          <div class="legend-item-text">
            {{ $t('text.fall').toLowerCase() }}
          </div>
        </div>
        <div class="legend-item">
          <div
            class="pad-group"
            :class="{
              'filter-selected': isFilterSelected(smartzEventConst.reposition)
            }"
            @click="updateFilters(smartzEventConst.reposition)"
          >
            <div class="smart-event-icon reposition">
              <img src="@/assets/image/VoidingPatternIcon/reposition.png" />
            </div>
          </div>
          <div class="legend-item-text">
            {{ $t('text.reposition').toLowerCase() }}
          </div>
        </div>
        <div class="legend-item">
          <div
            class="pad-group"
            :class="{
              'filter-selected': isFilterSelected(smartzEventConst.temperature)
            }"
            @click="updateFilters(smartzEventConst.temperature)"
          >
            <div class="smart-event-icon temperature">
              <img src="@/assets/image/VoidingPatternIcon/temperature.png" />
            </div>
          </div>
          <div class="legend-item-text">
            {{ $t('text.temperature').toLowerCase() }}
          </div>
        </div>
        <div class="legend-item">
          <div
            class="pad-group"
            :class="{
              'filter-selected': isFilterSelected(
                smartzEventConst.safeTimeExceed
              )
            }"
            @click="updateFilters(smartzEventConst.safeTimeExceed)"
          >
            <div class="smart-event-icon exceed-safe-time-in-pad">
              <img
                src="@/assets/image/VoidingPatternIcon/exceed-safe-time-in-pad.svg"
              />
            </div>
          </div>
          <div class="legend-item-text">
            {{
              $t('text.exceed_safe_time_in_pad', {
                pad: $store.state.locale.pad
              }).toLowerCase()
            }}
          </div>
        </div>
        <div class="legend-item">
          <div
            class="pad-group"
            :class="{
              'filter-selected': isFilterSelected(
                smartzEventConst.allowedTimeExceed
              )
            }"
            @click="updateFilters(smartzEventConst.allowedTimeExceed)"
          >
            <div class="smart-event-icon predicted-change-time">
              <img
                src="@/assets/image/VoidingPatternIcon/predicted-change-time.svg"
              />
            </div>
          </div>
          <div class="legend-item-text">
            {{ $t('text.predicted_change_time').toLowerCase() }} /
            {{ $t('text.predicted_red').toLowerCase() }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { smartzEventConst } from '@/components/patients/charts/smartzEventsChart/SmartzEventConst.js'
export default {
  data() {
    return {
      smartzEventConst,
      selectedFilter: [
        smartzEventConst.analysing,
        smartzEventConst.padRemoved,
        smartzEventConst.external,
        smartzEventConst.green,
        smartzEventConst.yellow,
        smartzEventConst.red,
        smartzEventConst.diaperNotUsed,
        smartzEventConst.unstable,
        smartzEventConst.diaperNotSelected,
        smartzEventConst.leakage,
        smartzEventConst.clumped,
        smartzEventConst.clumpedGreen,
        smartzEventConst.clumpedYellow,
        smartzEventConst.sensorDisconnected,
        smartzEventConst.checkConnection
      ]
    }
  },
  computed: {
    isFilterSelected() {
      return (val, isPadUsed = false) => {
        if (isPadUsed) {
          return this.selectedFilter.indexOf(this.smartzEventConst.green) > -1
        }
        return this.selectedFilter.indexOf(val) > -1
      }
    }
  },
  watch: {
    selectedFilter() {
      this.$emit('updateData')
    }
  },
  methods: {
    updateFilters(val) {
      let data = [val]
      if (val === smartzEventConst.green) {
        data.push(smartzEventConst.red)
        data.push(smartzEventConst.yellow)
      }
      if (val === smartzEventConst.allowedTimeExceed) {
        data.push(smartzEventConst.predictedRed)
      }
      if (val === smartzEventConst.clumped) {
        data.push(smartzEventConst.clumpedGreen)
        data.push(smartzEventConst.clumpedYellow)
      }
      if (val === smartzEventConst.goalTimeExceed) {
        data.push(smartzEventConst.padCheckAlertWet)
      }
      data.forEach(item => {
        let index = this.selectedFilter.indexOf(item)
        if (index > -1) {
          this.selectedFilter.splice(index, 1)
        } else {
          this.selectedFilter.push(item)
        }
      })
    }
  }
}
</script>
